import { ReactNode } from 'react';
import Box from '@material-ui/core/Box';
import {
  PhaseStructureTypeEnum,
  SubdivisionOverrideTypeEnum,
} from '@vatos-pas/common';
import { Control, FieldValues } from 'react-hook-form';
import { getFieldsForWorkflow } from '../../config/costStructureFields';
import { CostFieldSection } from './CostFieldSection';
import { OverrideTypeRadio } from './OverrideTypeRadio';

type CostStructureFieldsProps<T extends FieldValues> = {
  phaseStructureType: PhaseStructureTypeEnum;
  overrideTypeDisabled?: boolean;
  control: Control<T>;
  onOverrideTypeChange: (value: SubdivisionOverrideTypeEnum) => void;
  overrideTypeValue?: SubdivisionOverrideTypeEnum;
  warrantyFooter?: ReactNode;
};

export const CostStructureFields = <T extends FieldValues>({
  phaseStructureType,
  overrideTypeDisabled = false,
  control,
  onOverrideTypeChange,
  overrideTypeValue,
  warrantyFooter,
}: CostStructureFieldsProps<T>) => {
  const fields = getFieldsForWorkflow(phaseStructureType);

  return (
    <Box width="100%" display="flex" flexDirection="column">
      <CostFieldSection
        title="Production Cost Structure"
        fields={fields.production}
        control={control}
        isFixedOverride={
          overrideTypeValue === SubdivisionOverrideTypeEnum.FIXED
        }
        isOffsetOverride={
          overrideTypeValue === SubdivisionOverrideTypeEnum.OFFSET
        }
      >
        <OverrideTypeRadio
          disabled={overrideTypeDisabled}
          onOverrideTypeChange={onOverrideTypeChange}
          value={overrideTypeValue}
        />
      </CostFieldSection>

      <CostFieldSection
        title="Warranty / Repair Cost Structure"
        fields={fields.warranty}
        control={control}
        footer={warrantyFooter}
      />

      <CostFieldSection
        title="Additional Payment Cost Structure"
        fields={fields.additional}
        control={control}
        isFixedOverride={
          overrideTypeValue === SubdivisionOverrideTypeEnum.FIXED
        }
      />
    </Box>
  );
};
